"use client";

import { useState } from "react";
import { ChevronUp, ChevronDown } from "lucide-react";
import ImageCarousel, { type CarouselImage } from "@/components/home/ImageCarousel";

// Add/remove entries here to change what shows in the FAQ carousel.
const FAQ_IMAGES: CarouselImage[] = [
  { src: "/img/teretana_unutra2.webp", alt: "Saiyan Gym unutrašnjost — žuti stupovi i crna podloga" },
  { src: "/img/saiyan3.webp", alt: "Saiyan Gym unutrašnjost — zidni mural s Goku likovima iznad sprava za trening" },
  { src: "/img/saiyan11.webp", alt: "Saiyan Gym unutrašnjost — funkcionalna zona sa žutim stupovima i crnom podlogom" },
];

const faqs = [
  {
    question: "Koliko teretana ima prostora i opreme?",
    answer:
      "Saiyan Gym je najveća teretana u Dubrovniku s više od 700 m² modernih sprava, slobodnih utega i funkcionalnih zona.",
  },
  {
    question: "Nudite li osobne treninge?",
    answer:
      "Da, naši treneri su dostupni za individualne treninge i planove prilagođene tvojim ciljevima.",
  },
  {
    question: "Ima li teretana dodatne sadržaje?",
    answer:
      "Da – osim vrhunske opreme, imamo i masažnu sobu za oporavak i relaksaciju nakon treninga.",
  },
];

export default function FaqSection() {
  const [openItems, setOpenItems] = useState<number[]>([]);

  function toggle(index: number) {
    setOpenItems((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  }

  return (
    <section className="bg-white py-16 sm:py-20">
      <div className="mx-auto max-w-6xl px-6 sm:px-8 lg:px-10">
        <h2 className="mb-10 text-4xl font-bold tracking-tight text-[#18181b] sm:text-5xl">
          Česta pitanja
        </h2>

        <div className="flex flex-col gap-10 lg:flex-row lg:gap-16">
          {/* Left — FAQ accordion */}
          <div className="flex w-full flex-col lg:w-[45%]">
            {faqs.map((faq, index) => (
              <div key={index}>
                <button
                  onClick={() => toggle(index)}
                  className="flex w-full items-start justify-between gap-4 py-6 text-left"
                  aria-expanded={openItems.includes(index)}
                >
                  <span className="text-base font-semibold text-[#18181b] sm:text-lg">
                    {faq.question}
                  </span>
                  {openItems.includes(index) ? (
                    <ChevronUp className="mt-0.5 h-5 w-5 flex-shrink-0 text-[#71717a]" />
                  ) : (
                    <ChevronDown className="mt-0.5 h-5 w-5 flex-shrink-0 text-[#71717a]" />
                  )}
                </button>

                {openItems.includes(index) && (
                  <p className="pb-6 text-sm leading-relaxed text-[#71717a] sm:text-base">
                    {faq.answer}
                  </p>
                )}

                {index < faqs.length - 1 && (
                  <div className="h-px w-full bg-[#E4E4E7]" />
                )}
              </div>
            ))}
          </div>

          {/* Right — gym image */}
          <div className="w-full lg:w-[55%]">
            <ImageCarousel images={FAQ_IMAGES} className="aspect-[4/3]" />
          </div>
        </div>
      </div>
    </section>
  );
}
